






























































































































































































































































import { Vue, Component } from 'vue-property-decorator';

@Component
export default class GermanSkills extends Vue {
  private showTimeline = 0;

  private publicPath = process.env.BASE_URL;

  private cvFirst = [
    {
      name: 'Name:',
      val: 'Mandaliya, Jeet Ajaybhai',
    },
    {
      name: 'Staatsangehörigkeit:',
      val: 'indisch',
    },
    {
      name: 'Geschlecht:',
      val: 'Männlich',
    },
    {
      name: 'E-mail:',
      val: '<a target="_blank" href="mailto:jeet.mandaliya7@gmail.com">jeet.mandaliya7@gmail.com</a>',
    },
  ];

  private headers = [
    {
      text: 'Sprache',
      align: 'start',
      value: 'name',
    },
    { text: 'Hören', value: 'hearing', align: 'center' },
    { text: 'Lesen', value: 'reading', align: 'center' },
    { text: 'Zusammenhängendes Sprechen', value: 'zspeaking', align: 'center' },
    { text: 'An Gesprächen teilnehmen', value: 'protein', align: 'center' },
    { text: 'Schreiben', value: 'write', align: 'center' },
  ];

  private desserts = [
    {
      name: 'HINDI',
      hearing: 'C2',
      reading: 'C2',
      zspeaking: 'C1',
      protein: 'C1',
      write: 'C1',
    },
    {
      name: 'ENGLISCH',
      hearing: 'C1',
      reading: 'C1',
      zspeaking: 'C1',
      protein: 'C1',
      write: 'C1',
    },
    {
      name: 'DEUTSCH',
      hearing: 'C1',
      reading: 'C1',
      zspeaking: 'C1',
      protein: 'C1',
      write: 'C1',
    },
  ];

  private years = [
    {
      color: 'cyan',
      year: '11. September 2000',
      title: 'Geburt',
    },
    {
      color: 'green',
      year: '2006',
      title: 'Einstieg in schulische Bildung',
      disc: 'New Era Primary-School, Rajkot, Gujarat',
    },
    {
      color: 'pink',
      year: '2012',
      title: 'Start mit Web-Entwicklung',
      disc: 'Eingeführt in die Welt der Front-End-Web-Entwicklung mit HTML & CSS.',
    },
    {
      color: 'amber',
      year: '2015 - 2016',
      title: 'Meilenstein: 10. Klasse',
      disc: '3. Platz bundesweit mit Durchschnittsnote von 94,5 % und 99,97 PR(Perzentil-Rang)',
    },
    {
      color: 'orange',
      year: '2016 - 2018',
      title: 'Meilenstein: 12. Klasse',
      disc: `
        <ul>
          <li data-aos="fade-left"> Hauptfächer: Mathe, Physik und Chemie. </li>
          <li data-aos="fade-left"> Durchschnittsnote: 2,2 mit 98,83 PR. </li>
        </ul>
      `,
    },
    {
      color: 'cyan',
      year: 'Juni 2018 - Dez 2018',
      title: 'Vorbereitung auf die IELTS-Prüfung und das Goethe-Zertifikat A1',
      disc: `<ul>
          <li data-aos="fade-right"> Abschluss des A1 Niveau Deutsch mit Erwerb des Goethe-Zertifikats A1 am Goethezentrum, Ahmadabad (mit 94 Punkten bestanden). </li>
          <li data-aos="fade-right"> IELTS Prüfung im Oktober 2018 (mit 7.0 Bands und CEFR Niveau C1 bestanden). </li>
        </ul>
      `,
    },
    {
      color: 'green',
      year: 'Aug 2018',
      title: 'Mit dem Lernen von Full-Stack Web-Entwicklung angefangen',
      disc: 'Erste Begegnung mit der ganz neuen Welt von Erstellung atemberaubender Web-Apps mit NodeJS, ExpressJS, MongoDB und Mongoose mit EJS Templating.',
    },
    {
      color: 'pink',
      year: 'Jan 2019 - Juni 2019',
      title: 'Deutsch Sprachkurs',
      disc: `Verbesserung meiner Deutschkenntnisse von A2 auf B2 Niveau bei GLS Sprachenzentrum, Berlin. <br/>
        <ul>
          <li data-aos="fade-right""> Telc B2 Prüfung, Mai 2019 mit 263 aus 300 Punkten bestanden. </li>
        </ul>
      `,
    },
    {
      color: 'amber',
      year: 'Juni 2019',
      title: 'Erstes großes Web-Dev-Event',
      disc: 'Freiwilliger am WeAreDevelopers World-Congress, Juni 2019, Berlin.',
    },
    {
      color: 'orange',
      year: 'Aug 2019',
      title: 'Beginn des Studienkollegs an der TU Berlin',
      disc: `T - Kurs (Technik-Kurs):
        <ul>
          <li data-aos="fade-right">Hauptfächer: Deutsch, Mathematik, Physik.</li>
          <li data-aos="fade-right">Nebenfächer: Chemie, Informatik.</li>
        </ul>
      `,
    },
    {
      color: 'cyan',
      year: 'Okt 2019 - heute',
      title: 'Erste Berufserfahrung',
      disc: `Werkstudent - Frontend-Entwickler bei Rosenmeister LegalTech GmbH(später: Legislayer GmbH), Berlin <br/> <br/>
        Aufgaben:
        <ul>
          <li data-aos="fade-left"> Verwaltung, Testing(Unit und E2E) und Verbesserung der Software(SaaS) namens Hyperbot für Anwälte zur digitalen Fallbearbeitung </li>
          <li data-aos="fade-left"> Umsetzung von GitHub-Actions, AWS CodeBuild Actions und Pre-Commit-Hooks für einen optimierten Workflow</li>
          <li data-aos="fade-left"> Integration von Zapier mit API von Hyperbot zur Automatisierung der Datenübertragung</li>
        </ul>
      `,
    },
    {
      color: 'green',
      year: 'Juni 2019',
      title: 'Feststellungsprüfung am Studienkolleg',
      disc: `
        Durchschnittsnote: 1.4
      `,
    },
    {
      color: 'pink',
      year: 'Oct 2020',
      title: 'B.Sc. Informatik an der TU Berlin',
      disc: `
        Aktuell im 3. Semester.
      `,
    },
    // {
    //   color: 'amber',
    //   year: 'Seit immer',
    //   title: 'Ziele',
    //   disc: `
    //     <ul>
    //       <li data-aos="fade-left"> Informatikstudium an der TU Berlin abschließen. </li>
    //       <li data-aos="fade-left"> Full-Stack Web-Ingenieur werden. </li>
    //     </ul>
    //   `,
    // },
  ].reverse();

  get showCv(): boolean {
    return !!this.$route.name?.includes('cv');
  }
}
